module.exports = __webpack_public_path__ + "img/ad_img.24b6f1ff.png";